import { render, staticRenderFns } from "./VoiceConsultationModal.vue?vue&type=template&id=1e0de1ab&scoped=true"
import script from "./VoiceConsultationModal.vue?vue&type=script&lang=js"
export * from "./VoiceConsultationModal.vue?vue&type=script&lang=js"
import style0 from "./VoiceConsultationModal.vue?vue&type=style&index=0&id=1e0de1ab&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0de1ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e0de1ab')) {
      api.createRecord('1e0de1ab', component.options)
    } else {
      api.reload('1e0de1ab', component.options)
    }
    module.hot.accept("./VoiceConsultationModal.vue?vue&type=template&id=1e0de1ab&scoped=true", function () {
      api.rerender('1e0de1ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/treatment/treatment/VoiceConsultationModal.vue"
export default component.exports